import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    paymentServices: {
      minHeight: 52,
      justifyContent: 'center',
      width: '80%',
      margin: '0 auto',
    },
    orText: {
      textAlign: 'center',
      fontWeight: 400,
      fontSize: 14,
      margin: '10px 0',
    },
  }),
);
